module.exports = __webpack_public_path__ + "static/media/M.e0de0404.png";